export default __webpack_public_path__ + "static/alioforlogo-22aeaa51db1e56515415ea5e5de5119d.png";